var render = function (_h,_vm) {var _c=_vm._c;return (_vm.$options.methods.hasPower(_vm.props))?_c('div',[_vm._v("\n  "+_vm._s(_vm.props.row[_vm.props.column.field])+" kW ("+_vm._s(_vm.$options.methods.getHorsepower(_vm.props))+" PS)\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }